// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__gnxgv","skeletonLoader":"styles_skeletonLoader__aV8_b"};